// UWAGA: Wykorzystane w OPAC
import { Controller } from "@hotwired/stimulus"
// import { Turbo } from "@hotwired/turbo-rails" //UWAGA: nie importować ponownie

// used in pair with tabs controller to update location `tab` param
export default class extends Controller {
  update ({currentTarget, params}) {
    const value = currentTarget.id
    const key = params.key

    const url = Turbo.navigator.location
    url.searchParams.set(key, value)
    Turbo.navigator.history.replace(url)
  }
}
